import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getEsignAnalyses, 
  getEsignAnalysis,
  clearLocalEsignAnalyses,
  clearLocalActiveEsignAnalysis
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  esignAnalysis: { 
    id: '', 
    input: null, 
    result: null, 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    esignAnalysis: false 
  }
};

const slice = createSlice({
  name: 'esignAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getEsignAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getEsignAnalyses.fulfilled, (state, action) => {
        const { esign_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...esign_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getEsignAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getEsignAnalysis.pending, (state) => {
        state.loading.esignAnalysis = true;
      })
      .addCase(getEsignAnalysis.fulfilled, (state, action) => {
        const { data: { esign_analysis }, cable } = action.payload;
        const foundedEsignAnalysis = !!_find(state.all.data, (s) => s.id === esign_analysis.id);
        const updatedEsignAnalysis = { ...state.esignAnalysis, ...esign_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedEsignAnalysis ? _map(state.all.data, (e) => e.id === esign_analysis.id ? { ...e, ...esign_analysis } : e) : [...[esign_analysis], ...oldAllData]; 
        const pagination = foundedEsignAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.esignAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedEsignAnalysis && !cable) state.esignAnalysis = updatedEsignAnalysis;       
      })
      .addCase(getEsignAnalysis.rejected, (state) => {
        state.loading.esignAnalysis = false;
      })
      .addCase(clearLocalEsignAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveEsignAnalysis, state => {
        state.esignAnalysis = initialState.esignAnalysis;
      })
  }
})

export default slice.reducer;